import React from 'react'
import CricketChart from './CricketChart'
import PayerChart from './PayerChart'

const AllChart = () => {
    return (
        <>
            <section className="drag-wrap">
                <div className="container-fluid">
                    <div className="row sortable">
                        <PayerChart/>
                        <CricketChart/>
                        <PayerChart/>
                        <CricketChart/>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AllChart